import { render, staticRenderFns } from "./solutionBanner.vue?vue&type=template&id=337f7d32&scoped=true&"
import script from "./solutionBanner.vue?vue&type=script&lang=js&"
export * from "./solutionBanner.vue?vue&type=script&lang=js&"
import style0 from "./solutionBanner.vue?vue&type=style&index=0&id=337f7d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f7d32",
  null
  
)

export default component.exports